import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiCommonService } from 'src/app-core/services/api-common.service';
import { CommonService } from 'src/app-core/services/common.service';

@Injectable({
  providedIn: 'root'
})
export class MarkupsService {

  constructor(
    private apiCommonService: ApiCommonService,
    private commonService: CommonService) {
  }

  getMarkupsList(searchQuery: string): Observable<object> {
    return this.apiCommonService.get(`Accounts/Markups?${searchQuery}`);
  }

  updateMarkupsList(data: object): Observable<object> {
    return this.apiCommonService.post('Accounts/UpdateMarkups', data);
  }



}
